<template>
  <div>
    {{showClosePopUp}} {{getConfirmBoxResponse}} <!-- {{getFileList}} -->
    <div v-if="showlist">
      <transition name="modal">
        <div class="modal-mask upl-holdNEW wdth-700" style="overflow-y: auto; display: block;">
          <div class="modal-wrapper">
            <div class="modal-container">
              <!--Modal header-->
              <div class="modal-header">
                <slot name="header" style="border:1px red;">
                  <!-- <h5 class="modal-title">File List</h5> -->
                  <h4 class="modal-title mt-2">Uploaded files</h4>
                  <button
                    type="button"
                    aria-label="Close"
                    class="close up-close"
                    @click.prevent="closePopUp('goBack')"
                  >×</button>
                </slot>
              </div>
              <!--Modal Body-->
              <div class="modal-body" v-if="filelist && filelist.length>0">
                <div class="fileulpd-sec">
                  <div class="row">
                    <div class="col-md-6">
                      <p class="sub-head-uplmodal" v-if="filelist.length>1">{{filelist.length+' Files uploaded'}}</p>
                      <p class="sub-head-uplmodal" v-else>{{filelist.length+' File uploaded'}}</p>
                    </div>
                    <div class="col-md-6">
                      <p class="p-blue1 sub-head-uplmodal pull-right" v-if="!isEncounterActive">This encounter is closed</p>
                    </div>
                  </div>
                </div>
                <div class="filelisthold">
                  <div class="row upl-hover" v-for="item in filelist">
                    <!-- <h4 class="modal-title">Report files</h4> -->
                    <div class="col-9">
                      <div class="test-reports-right">
                        <button class="btn btn-downloadico"></button>
                        <div class="filename">
                          <div class="row">
                            <div class="col-md-6">
                              <a @click.prevent="viewFile(item.report_file_key,'file',item.report_actual_name)" :href="getdownloadfileUrl" class="down-link tkout-wrap" data-toggle="tooltip" :title=item.report_actual_name>
                                <span class="down-link tkout-wrap">{{textEllipsis(item.report_actual_name,truncatelength)}}</span>
                              </a>
                            </div>
                            <div class="col-md-6 px-0">
                              <div class="timehold text-right" v-if="item.uploaded_date">{{item.uploaded_date}}</div>
                            </div>
                          </div>
                        </div>                        
                      </div>
                    </div>
                    <div class="col-3 pl-4 pr-0">
                      <div class="modal-upl-hold">
                        <ul>
                          <li class="pt-1">
                            <a @click.prevent="viewFile(item.report_file_key,'file',item.report_actual_name)" :href="getdownloadfileUrl" class="action-view" data-toggle="tooltip" data-original-title="View"></a>
                            <!-- <a v-if="isProvider && isEncounterActive" href="javascript:void(0);" class="action-delete" @click.prevent="deleteReport(item,'file')" data-toggle="tooltip" title data-original-title="Delete"></a> -->
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>                  
              </div>
              <div class="modal-body" v-if="!(filelist && filelist.length)" style="text-align:center;">
                No files have been added so far.
              </div>
              <div
        id="viewbalance"
        role="dialog"
        tabindex="-1"
        class="modal fade imgPreview"
        aria-modal="true"
      >
        <div class="modal-dialog modal-lg">
          <div class="modal-content file-content">
            <div class="modal-header">
               <h3 class="modal-title mb-4"></h3>
              <button type="button" data-dismiss="modal" class="close">
                ×
              </button>
            </div>
            <div class="modal-body">
             
              <div class="">
                <img :src="getdownloadfileUrl" alt="" />
                <div>
                  
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
            </div>
          </div>
        </div>        
      </transition>
    </div>
    <!-- <reportUploadPopUp ref="reportUploadPopupRef" :showmodal=showModal :parentObj=parentobj :encounterid=recentappointment.encounter_id :investigationid=selectedInvestigationId :selectedReportType=selectedReportType :selectedTestType=selectedTestType>
    <reportUploadPopUp ref="reportUploadPopupRef" :showmodal=showModal :parentObj=parentobj :encounterid=invObj.encounter_id :investigationid=invObj.unique_id :selectedReportType=invObj.category_name :selectedTestType=invObj.investigation_name :tenantid =invObj.tenant_id :filescanbeuploaded=parseInt(invObj.filescanbeuploaded,10) :webreportcanbeuploaded=parseInt(invObj.webreportcanbeuploaded,10) :maxreportfilecount=parseInt(invObj.maxreportfilecount,10) :maxwebreportcount=parseInt(invObj.maxwebreportcount,10)>
    </reportUploadPopUp>

    <reportUploadPopUp v-if="editableObj.editable_unique_id" ref="reportUpdatePopupRef" :updatemodal=showUpdateModal :parentObj=parentobj :encounterid=editableObj.editable_encounter_id :investigationid=editableObj.editable_unique_id :selectedReportType=editableObj.editable_category_name :selectedTestType=editableObj.editable_investigation_name :diagnosticcentername=editableObj.editable_diagnostic_center_name :uploadednotes=editableObj.editable_report_notes :reportweburl=editableObj.editable_report_webUrl :reportweburluname=editableObj.editable_report_webUrlUname :reportweburlpass=editableObj.editable_report_webUrlPass :tenantid=editableObj.editable_tenant_id :webreportid=editableObj.webReportId>
    </reportUploadPopUp> -->

    <transition name="fade">
        <Messages v-if="isdisplaymsg" :datamessage="sucessmsgtext" v-on:closemsg="closeMessage" v-bind:isVisible="isdisplaymsg"></Messages>
    </transition>
    <!-- Confirm POP UP START-->
    <ConfirmBox ref="confirmcomp" :showmodal="showCnfrmPopUp" :actionmessage="actionMsg" @cancelAction="showCnfrmPopUp = false; confrmPopUpResponse = false;" @confirmAction="showCnfrmPopUp = false; confrmPopUpResponse = true;">
        <!--
            you can use custom content here to overwrite
            default content
            <h3 slot="header">{{customheadertxt}}</h3>
        -->
    </ConfirmBox>
    <!-- Confirm POP UP END-->
  </div>
</template>

<script>
// import reportUploadPopUp from "@/components/TestReportComponent/TestReportPopup.vue";
import rest_service from '@/api/rest_service';
import Axios from 'axios';
import { mapActions, mapGetters, Store } from 'vuex';
import Messages from "@/components/MessagePopup/Messages";
import ConfirmBox from "@/components/MessagePopup/ConfirmPopup";
import moment from "moment";
import Auth from "@/common/mixins";

var getinvestigationbyencounterurl = "/investigation/getinvestigationbyencounteranduniqueid";
var patient_report_delete_url = '/investigation/deleteTestReportByPatient';
var getencounterstatusurl = "/formrender/checkencounterstatus"

export default {
  mixins:[Auth],
  props: ["showlist", "parentObj" , "filelist"],
  components:{
    //   reportUploadPopUp,
      Messages,
      ConfirmBox
    },
  data() {
    return {
      show_modal: false,
      parentproperty: this.parentObj,
      invObj:[],
      showModal:false,
      parentobj:this,
      selectedTestType:"",
      selectedReportType:"",
      selectedInvestigationId:"",
      encounterIdL:"",
      showUpdateModal: false,
      loggedincustomerdetails:{},
      tenant_id:"",
      loggedin_user_unique_id : "",
      role_unique_id:"",
      authenticationToken:"",
      getFileListFromParent:false,
      isdisplaymsg:false,
      sucessmsgtext:"",
      getdownloadfileUrl:"",
      showCnfrmPopUp:false,
      confrmPopUpResponse:false,
      actionMsg:"Are you sure want to",
      customheadertxt:"Confirm Action",
      showauthenticationcheck: false,
      recordToDelete:null,
      recordType:"",
      isProvider:true,
      reportListIndex:0,
      needMultipleBtn:false,
      editableObj:{
        editable_encounter_id:"",
        editable_unique_id:"",
        editable_category_name:"",
        editable_investigation_name:"",
        editable_diagnostic_center_name:"",
        editable_report_notes:"",
        editable_report_webUrl:"",
        editable_report_webUrlUname:"",
        editable_report_webUrlPass:"",
        editable_tenant_id:"",
        webReportId:""
      },
      isEncounterActive:false,
      truncatelength: parseInt(process.env.VUE_APP_TEXT_TRUNCATE_LENGTH,10),
    };
  },
  created() {
    if(Auth.checkAuthentication()){
      this.tenant_id = localStorage.tenantid;
      this.authenticationToken = localStorage.accesstoken;
      if(localStorage.loggedInUserInfo)
      {
        let loggedinuser = JSON.parse(localStorage.loggedInUserInfo);
        this.loggedin_user_unique_id = loggedinuser.unique_id;
        this.role_unique_id = loggedinuser.role.unique_id; 
      }
      this.checkencounterstatus();
    }
  },
  mounted() {
  },
  methods: {
    closePopUp: function(item) {
      if (item === "goBack") {
        if(this.$parent.showuploadedfilelist){
          this.$parent.showuploadedfilelist = false;
        }
      }
    },
    checkencounterstatus(){
      var apiUrl=rest_service.baseURL+getencounterstatusurl+'?range_key='+this.$parent.encounterID;
      Axios.get(apiUrl,{
        headers: {
            "x_tenant_id": this.tenant_id,
            "role_unique_id": this.role_unique_id,
            "route_entity_name": '/formrender',
            "loggedin_user_unique_id": this.loggedin_user_unique_id,
            "Authorization": this.authenticationToken
        }
      })
      .then((xy)=>{
        if(xy && xy.data && xy.data.result){
          this.isEncounterActive = xy.data.result.record_status === 2 ? false:true;
        }
      })
      .catch((c)=>{
        console.error("Some Error Occured>>>.",c);
      })
    },
    textEllipsis(str, maxLength) {
      return Auth.truncTextEllipsis(str,maxLength);
    },
    viewFile: function(itemKey, report_Type,extension) {
      this.getdownloadfileUrl = null;
      if (typeof itemKey === "string" && itemKey && report_Type === "file") {
        this.foldername = this.tenant_id + this.$store.state.helper.tenant_s3upload_Folders.UploadedImagePath + itemKey;
      }
      this.viewItem = true;
      this.downLoadItem = false;
      if(Auth.checkAuthentication()){
        this.getUrlFromS3Bucket(this.foldername,extension);
      }
    },
    getUrlFromS3Bucket(fileKey,extension) {
        var self=this;
        var suburl="/S3Proxy";
        var apiUrl = rest_service.baseURL + suburl + "/getfileurl";
        return Axios.get(apiUrl,{
          headers: {
              "x_tenant_id": this.tenant_id,
              "role_unique_id": this.role_unique_id,
              "route_entity_name": suburl,
              "loggedin_user_unique_id": this.loggedin_user_unique_id,
              "Authorization": this.authenticationToken,
              "report_key": fileKey
          }
        })
        .then(function (response) {
            if (response != null && response.data != null) {
              self.getdownloadfileUrl= response.data.result;
              if (!/\.(gif|jpg|jpeg|png|webp)$/i.test(extension)) {
                window.open(self.getdownloadfileUrl,"_blank","channelmode=1");
              }
              else{
                $("#viewbalance").modal("show");
              }
              //console.log("REPORT VIEW URL>>>>>",self.getdownloadfileUrl);
              
            }
            else {
                return null;
            }
        })
        .catch(function (error) {
            return error;
        });
    },
    formatDate(dt){
      return moment(dt).format("DD-MM-YYYY hh:mm A");
    },
  },
  computed: {
    showClosePopUp() {
      var self = this;
      self.show_modal = self.showlist;
      if (!self.showlist) 
      {
        this.reportListIndex = 0;
        document.body.classList.remove("modal-open");
      }
      else{
        document.body.classList.add("modal-open");
      }
    },
    getParentProperty(){
      this.parentproperty = this.parentObj;
    },
    getConfirmBoxResponse(){
      if(this.confrmPopUpResponse){
        this.confirmDelete(this.recordToDelete, this.recordType);
      }
      else{
        this.confrmPopUpResponse = false;
      }
    }
  },
  watch: {
    show_modal: function(val,oldVal){
        //this.getFileListFromParent = !val;
    }    
  },
  updated(){}
};
</script>




<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: table;
  transition: opacity 0.3s ease-in-out;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 500px;
  margin: 0px auto;
  padding: 20px 50px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: opacity 0.5s ease-in-out;
 
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.filelisthold{max-height: 300px;
    overflow-y: auto;
    overflow-x: hidden;}
.reportlist-cred {
    width: 100%;
    display: block;
    float: left;
    /* background: #f3f7fa !important; */
    padding: 8px;
}

.reportlist-cred p:first-child {
    width: 100%;
    display: block;
    padding: 0 0;
    margin: 0 0 8px 0;
    }

.reportlist-cred p{margin-bottom: 0px; font-weight: 400; text-align:left;} 


.global-edit-ico {
    background: url(../../static/images/material_co_icon.png) -102px -242px no-repeat;
    width: 35px;
    height: 22px;
    display: inline-block;
    border-bottom: 0px !important;
    position: relative;
    right: 8px
}
.modal-mask.upl-holdNEW .modal-header {
    padding: 0;border: 0;
}
.modal-mask.upl-holdNEW h4.modal-title {
    text-align: center;
    width: 100%;
}
.modal-mask.upl-holdNEW .modal-body {
    padding: 20px 0 0 0!important;
    margin-top: 0;
}
p.sub-head-uplmodal {
    font-weight: 500;
    text-align: left;
    border-bottom: 1px solid #f1f1f1;
    padding-bottom: 4px;
}
.filelisthold{
    max-height: 300px;
    overflow-y: auto;
    overflow-x: hidden;
}
.row.upl-hover {
    margin-bottom: 0;
    padding: 10px 0 10px 10px;
}
.btn.btn-downloadico, .btn.btn-downloadico:active, .btn.btn-downloadico:focus {
    background: url(../../static/images/dashboard-newicons.png) 1px -741px no-repeat!important;
    width: 35px;
    height: 40px;
    float: left;
    display: block;
    outline: 0;
    -webkit-box-shadow: 0 0 0 .2rem rgba(0,123,255,0)!important;
    box-shadow: 0 0 0 .2rem rgba(0,123,255,0)!important;
    cursor: pointer;
    background-color: #f3f7fa!important;
}
.test-reports-right a.down-link.tkout-wrap {
    width: auto;
    white-space: inherit;
    overflow: visible;
    text-overflow: inherit;
    padding:0 8px 2px;
    float: left;
}
.reportlist-cred .user-nameicon, .reportlist-cred .user-pwicon {
    width: 28px;
    height: 20px;
    display: inline-block;
    margin-right: 0;position: relative;top:4px;
}
.user-nameicon {
    background: url(../../static/images/signin-icon.png) -0px -2px no-repeat!important;
        background-size: 80px auto !important;
    -webkit-filter: grayscale(100%);
    filter: grayscale(100%);
}
.user-pwicon {
    background: url(../../static/images/signin-icon.png) -0px -44px no-repeat!important;
        background-size: 80px auto !important;
    -webkit-filter: grayscale(100%);
    filter: grayscale(100%);
}
.filename{float: left; width: calc(100% - 35px);}
.timehold{font-size: 13px;padding: 0 8px ;float: left;width: 100%; text-align:left;}

.prevnxt-btnhold {width:450px; margin: 0 auto; display: flex;}
.prevnxt-btnhold .label-hold, .prevnxt-btnhold .label-hold span {text-align: center; display: inline-block; width:342px; word-break: break-word; font-weight: 500; font-size: 14px; padding: 2px 0;}
.prevnxt-btnhold .fc-state-default.fc-corner-left, .prevnxt-btnhold .fc-state-default.fc-corner-right{border-radius: 50%; width: 30px; height: 30px; padding: 6px; justify-content: center;}
.prevnxt-btnhold .fc-state-default.fc-corner-left:focus, .prevnxt-btnhold .fc-state-default.fc-corner-right:focus{ outline: transparent;}
.modal-mask.upl-holdNEW.wdth-700 .modal-container{width:700px;}

.modal-mask:before {
    display: inline-block;
    vertical-align: middle;
    content: " ";
    height: 100%;
  }


.modal-wrapper {
  display: inline-block;
  text-align:left;
  vertical-align: middle;
  width: 100%;
}
.view-balance .modal-dialog .modal-content.file-content {
    padding: 0;
    min-width: 600px;
    left: -25%;
}
.wallet-balance img {
    margin-right: 20px;
    margin: 0 auto;
    display: block;
    max-width: 100%;
}
.reportlist-cred{text-align: left;}
.row.upl-hover:hover {background: #f8f9fa;}
.fileulpd-sec{width:100%; margin: 0 auto; display:block; border-bottom:1px solid #f1f1f1; margin-bottom:10px;}
.fileulpd-sec p.sub-head-uplmodal{border-bottom:0px solid transparent; margin-bottom: 0;}
p.p-blue1.sub-head-uplmodal{color: #0157e0;}
button.fc-prev-button.fc-button.fc-state-default.fc-corner-left.invest-pre-BTN {background: #c9cdd4; color: #55627b; border: 0px transparent; padding:5px 4px; height:26px; width:26px; text-shadow: none !important; box-shadow: none !important;cursor: pointer;}
button.fc-next-button.fc-button.fc-state-default.fc-corner-right.invest-nxt-BTN {background: #c9cdd4; color: #55627b; border: 0px transparent; padding:5px 4px; height:26px; width:26px; text-shadow: none !important; box-shadow: none !important;cursor: pointer;}
button.fc-prev-button.fc-button.fc-state-default.fc-corner-left.invest-pre-BTN:hover, button.fc-next-button.fc-button.fc-state-default.fc-corner-right.invest-nxt-BTN:hover{background: #55627b; color: #ffffff;}

.imgPreview .modal-body img {
    max-width: 100%;
    max-height: 500px;
    margin: 0 auto;
    display: block;
}
.modal-mask.upl-holdNEW .imgPreview .close {
    right: 10px;
}
</style>
